function show (elem) {
	elem.style.display = 'block';
};

function hide (elem) {
	elem.style.display = 'none';
};

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validate_signup2(frm) {
    var userAgent = navigator.userAgent;
    var u_check = false;
    //Honey
    var h_pot = frm.oosFieldCheck.value;
    var h_check1 = false;
    var emailAddress = frm.OOSEmail.value;
    var errorCheck = false;
    var e_input = document.getElementById("OOSEmail")
    var e_err = document.getElementById("email_error")
    var e_check = false;

    if (emailAddress == '' || !validateEmail(emailAddress)) {
        e_check = true;
        e_err.innerHTML = "Please input a valid email address";
        e_err.classList.remove("no_error");
        e_err.classList.add("input_error");
        e_input.classList.add("f_invalid_input");
    } else if (emailAddress != '' || validateEmail(emailAddress)) {
        e_check = false;
        e_err.innerHTML = "";
        e_err.classList.remove("input_error");
        e_err.classList.add("no_error");
        e_input.classList.remove("f_invalid_input");
    }
    if (userAgent == '' || userAgent == null || userAgent == undefined) {
        u_check = true;
    }
    if (h_pot != '') {
        h_check1 = true;
    }
    if (!e_check && !u_check && !h_check1) {
        errorCheck = true;
    }
    return errorCheck
}

function submitOOSNotificationRequest(){
  event.preventDefault(); 
   
  var frm = document.getElementById("oosProduct");
  var oosAlreadyProduct = false;
  var oosProductId = document.getElementById("OOSProductId").value;
  var oosResult = document.getElementById("oosFormCont");
  
  if (getCookie('oos-cookie') == oosProductId) { oosAlreadyProduct = true; }
  
  if (validate_signup2(frm) && !oosAlreadyProduct) {
      subOOS();
  } else {
    oosResult.innerHTML = "<div id=\"oosSuccess\"><div id=\"oosHeader\">Success</div><div id=\"oosSBody\">We will email you as soon as our next crop is ready. Thank you for your patience.</div></div>";
  }
}

function subOOS() {    
    var oosForm = document.getElementById("oosProduct");
    var oosSpin = document.getElementById("oosSpin");
    var oosResult = document.getElementById("oosFormCont");
    var post_url = 'https://hgfn-prod-webapi.azurewebsites.net/api/Connector/stock-notifications';
    var request_method = 'POST';
    var form_data = {
      'Email': document.getElementById("OOSEmail").value,
      'StoreId': document.getElementById("OOSStoreId").value,
      'AlternateId': document.getElementById("OOSProductId").value,
      'Url': document.getElementById("OOSUrl").value
    };
  
    hide(oosForm);
    show(oosSpin);

    fetch(post_url, {
        method: 'POST', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(form_data)
    })
    .then(response => response.json())
    .then(data => {
      hide(oosSpin);
      oosResult.innerHTML = "<div id=\"oosSuccess\"><div id=\"oosHeader\">Success</div><div id=\"oosSBody\">We will email you as soon as our next crop is ready. Thank you for your patience.</div></div>";
      createCookie('oos-cookie', form_data.AlternateId, 1);
    })
    .catch(error => {
        console.error('Error:', error);
        hide(oosSpin);
    });
}

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for(let i = 0; i <cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return null;
}
